import * as React from "react";
const SvgFiRrHardHat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 16v-3.08c0-4.734-3.183-8.918-7.78-10.293a4 4 0 0 0-6.44 0C4.182 4.002 1 8.186 1 12.92V16a1 1 0 1 0 0 2h.475C2.477 19.348 5.768 23 12 23s9.522-3.652 10.525-5H23a1 1 0 1 0 0-2m-2-3.08V16h-5V5.069c3.011 1.457 5 4.484 5 7.851M12 3a2 2 0 0 1 2 1.994V16h-4V4.994C10 3.894 10.897 3 12 3M8 5.069V16H3v-3.08c0-3.367 1.988-6.394 5-7.851M4.141 18h15.704c-1.389 1.312-3.936 3-7.845 3-3.939 0-6.479-1.687-7.859-3"
    />
  </svg>
);
export default SvgFiRrHardHat;
